module.exports = __webpack_public_path__ + "static/img/ymxg1920x180_2.4b430af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ymxg1920x180_2.jpg
// module id = z8Vt
// module chunks = 6